{
  "login": "Connexion",
  "logout": "Déconnexion",
  "email": "E-mail",
  "emailAddress": "Adresse e-mail",
  "emailPlaceholder": "user@example.com",
  "password": "Mot de passe",
  "forgotPassword": "Mot de passe oublié ?",
  "rememberMe": "Se souvenir de moi",
  "signIn": "Se connecter",
  "signUp": "S'inscrire",
  "user": "Utilisateur",
  "tagline": "Plateforme d'opérations locatives",
  "welcomeBackSubtitle": "Ravi de vous revoir. Veuillez saisir vos identifiants.",
  "createAccountSubtitle": "Créez un compte pour commencer à gérer vos biens.",
  "showPassword": "Afficher le mot de passe",
  "hidePassword": "Masquer le mot de passe",
  "quickAccess": "Accès rapide (QA)",
  "quickUsers": {
    "platform_sovereign": "Admin Souverain Plateforme ({{name}})",
    "platform_admin": "Admin Plateforme ({{name}})",
    "admin": "Admin ({{name}})",
    "manager": "Gestionnaire ({{name}})",
    "owner": "Propriétaire ({{name}})",
    "tenant": "Locataire ({{name}})",
    "vendor": "Prestataire ({{name}})",
    "multi": "Multi-Rôles Adaptatif ({{name}})"
  },
  "enterEmail": "Veuillez saisir une adresse e-mail",
  "loginFailed": "Échec de la connexion",
  "authFailed": "Échec de l'authentification",
  "apiError": "{{message}}",
  "guestSessionDetected": "Session invité active",
  "guestSessionDescription": "Vous avez un brouillon invité non enregistré. Vous connecter enregistrera et associera automatiquement votre travail à votre compte.",
  "guestSessionMigrated": "Votre brouillon invité a bien été enregistré sur votre compte.",
  "passwordMode": "Mot de passe",
  "magicLinkMode": "Lien magique",
  "sendMagicLink": "Envoyer le lien magique",
  "magicLinkSentTitle": "Consultez votre boîte e-mail",
  "magicLinkSentDescription": "Nous avons envoyé un lien magique de connexion à {{email}}. Cliquez sur le lien reçu pour vous connecter.",
  "signInWithPassword": "Se connecter avec un mot de passe",
  "signInWithMagicLink": "Se connecter avec un lien magique",
  "or": "ou",
  "resetPasswordTitle": "Réinitialiser votre mot de passe",
  "resetPasswordDescription": "Saisissez votre adresse e-mail et nous vous enverrons un lien de réinitialisation.",
  "sendResetLink": "Envoyer le lien de réinitialisation",
  "checkYourEmail": "Vérifiez votre boîte e-mail",
  "resetEmailSentNotice": "Si un compte existe pour {{email}}, un lien de réinitialisation a été envoyé.",
  "backToSignIn": "Retour à la connexion",
  "setNewPasswordTitle": "Créer un nouveau mot de passe",
  "setNewPasswordDescription": "Votre nouveau mot de passe doit comporter au moins 8 caractères, des majuscules et des chiffres.",
  "newPassword": "Nouveau mot de passe",
  "confirmNewPassword": "Confirmer le nouveau mot de passe",
  "saveNewPassword": "Réinitialiser le mot de passe",
  "ruleMinLength": "Au moins 8 caractères",
  "ruleUppercase": "Au moins une lettre majuscule",
  "ruleNumber": "Au moins un chiffre",
  "ruleMatch": "Les mots de passe correspondent",
  "passwordResetSuccessTitle": "Mot de passe réinitialisé avec succès",
  "redirectingToLogin": "Redirection vers la connexion...",
  "invalidResetLinkTitle": "Lien invalide ou expiré",
  "invalidResetLinkDescription": "Ce lien de réinitialisation est invalide ou a expiré.",
  "requestNewResetLink": "Demander un nouveau lien",
  "authenticatingLink": "Connexion en cours...",
  "pleaseWait": "Veuillez patienter pendant la validation de votre lien magique.",
  "magicLinkErrorTitle": "Impossible de se connecter",
  "requestNewLink": "Demander un nouveau lien de connexion",
  "tabs": {
    "signIn": "Connexion",
    "signUp": "Créer un compte"
  },
  "fields": {
    "fullName": "Nom complet",
    "fullNamePlaceholder": "Marie Dupont",
    "confirmPassword": "Confirmer le mot de passe",
    "phone": "Numéro de téléphone",
    "phonePlaceholder": "+1 555 123 4567"
  },
  "buttons": {
    "createAccount": "Créer un compte",
    "creatingAccount": "Création du compte..."
  },
  "errors": {
    "passwordMismatch": "Les mots de passe ne correspondent pas",
    "accountExists": "Un compte existe déjà avec cette adresse e-mail. Veuillez vous connecter."
  },
  "accountLinkedNotice": "Compte associé avec succès à {{provider}}.",
  "enterFullName": "Veuillez saisir votre nom complet (au moins 2 caractères)",
  "enterValidEmail": "Veuillez saisir une adresse e-mail valide",
  "passwordRequirementsNotMet": "Le mot de passe ne respecte pas les critères de sécurité",
  "organizationName": "Nom de l'organisation",
  "organizationDefaultPlaceholder": "Votre nom par défaut",
  "organizationDefaultNotice": "Votre espace de travail principal sera initialisé automatiquement.",
  "google": "Google",
  "facebook": "Facebook",
  "instagram": "Instagram",
  "whatsapp": "WhatsApp",
  "sms": "SMS",
  "providerUnavailableTooltip": "La connexion avec {{provider}} n'est pas encore configurée",
  "enterPhone": "Veuillez saisir un numéro de téléphone valide",
  "enterValidCode": "Veuillez saisir le code à 6 chiffres",
  "otpSendFailed": "Échec de l'envoi du code OTP",
  "otpVerifyFailed": "Code de vérification invalide",
  "otpPhoneDescription": "Nous vous enverrons un code de vérification à 6 chiffres par téléphone.",
  "otpCodeDescription": "Saisissez le code à 6 chiffres envoyé au {{phone}}.",
  "phoneFormatHint": "Incluez l'indicatif pays (ex. +56 pour le Chili, +33 pour la France).",
  "sendVerificationCode": "Envoyer le code de vérification",
  "changePhoneNumber": "Changer de numéro",
  "resendCode": "Renvoyer le code",
  "resendInCountdown": "Renvoyer dans {{count}}s",
  "cancelToSignIn": "Retour à la connexion",
  "useDifferentEmail": "Utiliser un autre e-mail",
  "missingMagicToken": "Jeton de lien magique manquant",
  "magicLinkVerifyFailed": "Impossible de valider le lien magique",
  "magicLinkRequestFailed": "Impossible d'envoyer le lien magique",
  "completingSocialLogin": "Finalisation de votre connexion...",
  "socialCallbackErrorTitle": "La connexion sociale n'a pas pu être finalisée",
  "socialCallbackDenied": "L'autorisation a été annulée ou refusée.",
  "unsupportedSocialProvider": "Fournisseur d'authentification sociale non pris en charge.",
  "missingSocialCode": "Code d'autorisation manquant du fournisseur de connexion sociale.",
  "invalidOAuthState": "Incohérence de sécurité lors de la connexion sociale. Veuillez réessayer.",
  "socialProviderNotConfigured": "Ce fournisseur de connexion sociale n'est pas configuré sur cet environnement.",
  "dataDeletionStatusTitle": "Suppression des données sociales terminée",
  "dataDeletionStatusDescription": "Votre identité de connexion sociale Meta (Facebook / Instagram) et les données associées ont été supprimées de HomyOS.",
  "dataDeletionCodeLabel": "Code de confirmation",
  "social": {
    "continueWithApple": "Continuer avec Apple",
    "signInWithApple": "Se connecter avec Apple",
    "continueWithGoogle": "Continuer avec Google",
    "continueWithFacebook": "Continuer avec Facebook",
    "continueWithInstagram": "Continuer avec Instagram",
    "continueWithWhatsApp": "Continuer avec WhatsApp",
    "continueWithSms": "Se connecter par SMS",
    "lastUsed": "Dernièrement utilisé",
    "orContinueWith": "Ou continuer avec",
    "providerDisabled": "Ce moyen de connexion est actuellement indisponible.",
    "placeholderToast": "La connexion avec {{provider}} sera disponible lors de la prochaine mise à jour. Sur mobile, utilisez Apple ou mot de passe."
  },
  "hero": {
    "badge": "HomyOS 2.0",
    "title": "Le système d'exploitation des opérations locatives.",
    "subtitle": "Gérez les logements, sélectionnez les locataires, signez les contrats et encaissez les loyers depuis une seule et même plateforme unifiée.",
    "pill1": "99,8% de loyers recouvrés à l'heure",
    "pill1Sub": "Rapprochement automatisé en UF",
    "pill2": "Répartition automatisée de la maintenance",
    "pill2Sub": "Validation des prestataires avec humain dans la boucle",
    "pill3": "Sélection des locataires par IA",
    "copyright": "© 2026 HomyOS",
    "privacy": "Confidentialité",
    "terms": "Conditions générales"
  },
  "qa": {
    "title": "Accès rapide développeur",
    "badge": "DEV QA",
    "description": "Basculez entre des profils préconfigurés pour auditer permissions, vues et flux de travail.",
    "groups": {
      "platform": "Plateforme & Opérations",
      "residents": "Résidents & Propriétaires",
      "contractors": "Prestataires & Terrain",
      "special": "Multi-Rôles Adaptatif"
    },
    "instantLogin": "Connexion en 1 clic",
    "fillForm": "Remplir les identifiants",
    "close": "Fermer"
  },
  "passkey": {
    "passkey": "Clé de sécurité",
    "signInWithPasskey": "Se connecter avec une clé de sécurité",
    "registerTitle": "Configurer une clé de sécurité",
    "registerDescription": "Connectez-vous en toute sécurité avec Touch ID, Face ID ou le verrouillage de votre écran sans taper de mot de passe.",
    "registerButton": "Ajouter une clé de sécurité",
    "prompt": "Utiliser Touch ID, Face ID ou une clé de sécurité",
    "notSupported": "Les clés de sécurité ne sont pas prises en charge par cet appareil ou ce navigateur.",
    "createdSuccess": "Clé de sécurité créée avec succès !",
    "authSuccess": "Clé de sécurité validée avec succès !",
    "failed": "Échec de l'authentification par clé de sécurité. Réessayez ou utilisez un mot de passe."
  },
  "mfa": {
    "challengeTitle": "Authentification à deux facteurs",
    "challengeDescription": "Saisissez le code de sécurité à 6 chiffres généré par votre application d'authentification.",
    "subtitleSms": "Saisissez le code de vérification à 6 chiffres envoyé sur votre téléphone.",
    "codeLabel": "Code de sécurité à 6 chiffres",
    "codePlaceholder": "000000",
    "verifyButton": "Vérifier & Se connecter",
    "verifying": "Vérification...",
    "useBackupCode": "Utiliser un code de secours",
    "useTotp": "Utiliser plutôt le code de l'application TOTP",
    "backupCodeLabel": "Code de secours",
    "backupCodeDescription": "Saisissez un code de secours à usage unique de 8 caractères.",
    "backupCodePlaceholder": "Code de secours (ex. ABCD-1234)",
    "invalidCode": "Code de sécurité invalide. Veuillez vérifier votre application et réessayer.",
    "invalidBackupCode": "Code de secours invalide ou déjà utilisé."
  },
  "slides": {
    "property": {
      "title": "Gestion immobilière centralisée.",
      "subtitle": "Gérez les logements, suivez les finances et visualisez les analyses sur une plateforme élégante et unifiée.",
      "pill1Title": "99,8% de loyers recouvrés à l'heure",
      "pill1Sub": "Rapprochement automatisé en UF",
      "pill2Title": "Copilote immobilier IA",
      "pill2Sub": "Analyses proactives de portefeuille"
    },
    "maintenance": {
      "title": "Répartition automatisée de la maintenance.",
      "subtitle": "Collaborez facilement avec des artisans vérifiés comme Patricio pour maintenir vos biens en parfait état.",
      "pill1Title": "Répartition automatisée de la maintenance",
      "pill1Sub": "Validation des prestataires avec humain dans la boucle",
      "pill2Title": "Devis intelligents",
      "pill2Sub": "Coûts de réparation vérifiés par IA"
    },
    "tenant": {
      "title": "Une expérience locataire supérieure.",
      "subtitle": "Accueil simplifié, baux 100% numériques et paiement fluide des loyers pour les locataires d'aujourd'hui.",
      "pill1Title": "Locations plus rapides",
      "pill1Sub": "Baux 100% numériques",
      "pill2Title": "Paiements sans friction",
      "pill2Sub": "Prélèvements automatiques"
    }
  },
  "oauth": {
    "title": "Autoriser {{clientName}}",
    "subtitle": "souhaite se connecter à votre espace de travail Homy",
    "clientUnknown": "Application Externe",
    "signInTitle": "Connectez-vous pour vous connecter à {{clientName}}",
    "signInSubtitle": "Créez un compte ou connectez-vous pour autoriser l'accès à votre espace de travail Homy.",
    "permissionsRequested": "Permissions demandées",
    "workspaceLabel": "Sélectionner l'espace de travail / Organisation",
    "workspaceDescription": "Choisissez l'organisation à laquelle cette application aura accès.",
    "workspacePlaceholder": "Sélectionnez une organisation...",
    "noWorkspaces": "Aucune organisation disponible",
    "currentAccount": "Connecté en tant que",
    "switchAccount": "Se connecter avec un autre compte",
    "starterOrgNotice": "Une organisation de départ sera automatiquement configurée pour votre compte.",
    "termsNotice": "En cliquant sur Autoriser, vous autorisez {{clientName}} à accéder à vos informations conformément à ses conditions et sa politique de confidentialité.",
    "authorizeButton": "Autoriser",
    "cancelButton": "Annuler",
    "authorizing": "Autorisation en cours...",
    "canceling": "Annulation...",
    "scopes": {
      "openid": "Vérifier votre identité (OpenID Connect)",
      "profile": "Accéder aux informations de profil de base (nom, avatar)",
      "email": "Consulter votre adresse e-mail",
      "offline_access": "Maintenir l'accès hors ligne via des jetons d'actualisation",
      "homy:all": "Accès complet aux données et opérations de l'espace de travail",
      "homy:mcp": "Exécuter des outils d'agents IA et des actions Model Context Protocol (MCP)",
      "mcp:read": "Accès en lecture aux propriétés, tâches, locataires et maintenance via MCP",
      "mcp:write": "Créer et modifier des tâches, ordres de maintenance et propriétés via MCP",
      "read": "Accès en lecture aux données de votre compte",
      "write": "Accès en écriture pour effectuer des actions en votre nom"
    },
    "errors": {
      "missingParams": "Demande d'autorisation non valide: paramètres obligatoires manquants (client_id, redirect_uri ou code_challenge).",
      "clientFetchFailed": "Impossible de vérifier les détails du client. Vous pouvez continuer si vous faites confiance à cette application.",
      "authorizeFailed": "Échec de l'autorisation. Veuillez réessayer.",
      "accessDenied": "La demande d'autorisation a été annulée."
    }
  }
}
